var moduleCommon = function() {
  var $ = jQuery,
      $html,
      $body,
      $mobileNav,
      $mobileNavToggle,
      $mobileSubNavToggle,
      _this;

  var module = {
    init: function() {
      _this = this;
      this.setVars();
      this.modifyDOM();
      this.addEvents();
      moduleGoogleMap();
      moduleGlobalBanner();
    },

    setVars: function() {
      $html                 = $('html');
      $body                 = $('body');
      $mobileNav            = $('.mobile-navigation');
      $mobileNavToggle      = $('.mobile-navigation-toggle');
      $mobileSubNavToggle   = $('.menu-item-has-children');
    },

    modifyDOM: function() {
      $('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');

        if (!a.test(this.href)) {
          $(this).click(function(event) {
            event.preventDefault();
            event.stopPropagation();
            window.open(this.href, '_blank');
          });
        }
      });
    },

    addEvents: function() {
      $mobileNavToggle.on('click', this.eventHandlers.showMobileMenu);
      $mobileSubNavToggle.on('click', this.eventHandlers.showMobileSubMenu);
      $('body').on('click', '.js-booking-continue', _this.eventHandlers.continueBooking).
                on('change', '.js-widget-manual-brand', _this.eventHandlers.continueBooking).
                on('keyup', '.js-widget-regnr [type="text"]', _this.eventHandlers.keyupRegnr).
                on('click', '.cars-list__overlay', _this.eventHandlers.iframeOverlayClicked);
    },

    eventHandlers: {
      iframeOverlayClicked: function() {
        window.location.href = $(this).data('redirect');
        return false;
      },

      keyupRegnr: function(e) {
        if (e.which === 13) {
          $('.js-booking-continue').click();
        }
      },

      continueBooking: function() {
        window.location.href = $('.js-booking-continue').attr('href') + '?regnr=' + $('.js-widget-regnr input').val() + '&manualBrand=' + $('.js-widget-manual-brand').val();
        return false;
      },

      showMobileMenu: function() {
        return $mobileNavToggle.hasClass('active') === true ? $mobileNavToggle.removeClass('active') && $mobileNav.removeClass('mobile-navigation--collapsed') && $html.removeClass('nav-open') : $mobileNavToggle.addClass('active') && $mobileNav.addClass('mobile-navigation--collapsed') && $html.addClass('nav-open');
      },

      showMobileSubMenu: function(e) {
        if(e.target.nodeName === 'A') {
          return;
        } else {
          e.preventDefault();
          e.stopPropagation();
        }
        $(this).toggleClass('collapsed').children('ul').toggle();
      }
    },

    helpers: {
      validateRegnr: function(input) {
        return input.match(/^[a-zA-Z]{3}\d{3}$/);
      }
    }
  };

  module.init();
};
